import React from "react";
import PropTypes from "prop-types";

const Pagination = ({
  start,
  end,
  totalRecord,
  isPrevDisabled,
  isNextDisabled,
  handlePrevPage,
  handleNextPage,
}) => {
  return (
    <div className="d-flex align-items-center justify-content-end mt-3">
      <span className="mx-4 pagination-text">
        Showing {start} to {end} of {totalRecord}
      </span>
      <span
        className={`pagination-arrow ${isPrevDisabled ? "disabled" : ""}`}
        onClick={handlePrevPage}
        style={{
          cursor: isPrevDisabled ? "not-allowed" : "pointer",
          opacity: isPrevDisabled ? 0.3 : 1,
        }}
      >
        <i className="pi pi-angle-left"></i>
      </span>
      <span
        className={`pagination-arrow mx-1 ${isNextDisabled ? "disabled" : ""}`}
        onClick={handleNextPage}
        style={{
          cursor: isNextDisabled ? "not-allowed" : "pointer",
          opacity: isNextDisabled ? 0.3 : 1,
        }}
      >
        <i className="pi pi-angle-right"></i>
      </span>
    </div>
  );
};

Pagination.propTypes = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  totalClients: PropTypes.number.isRequired,
  isPrevDisabled: PropTypes.bool.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
  handlePrevPage: PropTypes.func.isRequired,
  handleNextPage: PropTypes.func.isRequired,
};

export default Pagination;
